module.exports = __webpack_public_path__ + "img/refresh-left.46957d3c.png";